module.exports = __webpack_public_path__ + "img/glints.1adfce55.png";